import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { addReportToDossiers, Dossier, fetchDossiers, fetchReportDossiers } from '../../../services/stixify_api.ts';
import LoadingButton from '../../../components/loading_button/index.tsx';

const AddToDossierDialog = ({ open, onClose, teamId, reportId }: { teamId: string, reportId: string, open: boolean, onClose: () => void }) => {
    const [dossiers, setDossiers] = useState<Dossier[]>([])
    const [reportDossier, setReportDossier] = useState<{[key: string]: boolean}>({})
    const [selectedDossiers, setSelectedDossiers] = useState<string[]>([])
    const [loading, setLoading] = useState(false)

    const loadReportDossiers = async () => {
        const res = await fetchReportDossiers(teamId, reportId)
        const dossierIds = res.data.results.map(dossier => dossier.id)
        const reportDossier = dossierIds.reduce((acc, dossierId) => {
            acc[dossierId] = true
            return acc
        }, {} as {[key: string]: boolean})
        setReportDossier(reportDossier)
    }
        
    const loadDossiers = async () => {
        const res = await fetchDossiers(teamId, {team_id: teamId}, 1)
        setDossiers(res.data.results)
    }
    useEffect(() => {
        loadDossiers()
        loadReportDossiers()
    }, [])

    const addToDossiers = async () => {
        setLoading(true)
        const dossierIds = selectedDossiers.filter(dossierId => !reportDossier[dossierId]).map(dossierId => dossierId)
        await addReportToDossiers(teamId, dossierIds, reportId)
        onClose()
        setLoading(false)
    }

    useEffect(() => {
        setLoading(false)
    }, [open])
    return <Dialog open={open} onClose={onClose}>
        <DialogTitle><Typography variant="h4">Add to Dossier</Typography></DialogTitle>

        <DialogContent>
            <Typography>You can add a report to one or more dossiers.</Typography>
            <Select fullWidth multiline multiple value={selectedDossiers} onChange={(e) => setSelectedDossiers(e.target.value as string[])}>
                {dossiers.filter(dossier => !reportDossier[dossier.id]).map(dossier => <MenuItem key={dossier.id} value={dossier.id}>{dossier.name}</MenuItem>)}
            </Select>
        </DialogContent>
        <DialogActions>
            <Button variant='contained' onClick={onClose} color="error">
                Cancel
            </Button>
            <LoadingButton isLoading={loading} variant='contained' onClick={addToDossiers} color="primary">
                Add
            </LoadingButton>
        </DialogActions>
    </Dialog>
}

export default AddToDossierDialog